import { render, staticRenderFns } from "./AeraHospital.vue?vue&type=template&id=0ea78118&scoped=true"
import script from "./AeraHospital.vue?vue&type=script&lang=js"
export * from "./AeraHospital.vue?vue&type=script&lang=js"
import style0 from "./AeraHospital.vue?vue&type=style&index=0&id=0ea78118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea78118",
  null
  
)

export default component.exports